import { message } from 'antd';
import Trip from './Trip'
import { connect } from 'react-redux'
import { reduxForm, submit, initialize, getFormValues, change } from 'redux-form'
import onMount from '../core/onMount'
import { push } from 'react-router-redux'
import moment from 'moment'
import { getTrip, updateTrip, onSelectPurpose, deleteTrip, onDateChange, undoMerge } from './actions'
import { enableRoundTrip, requestDirections, disableRoundTrip } from '../map/actions'
import { getPurposes, calculateDeduction } from './reducer'
import {validate} from './'
const mapStateToProps = ({map, ...state}, ownProps) => {
  const { work_mileage_rate, irs_mileage_rates } = state.models.user
  const tripForm = getFormValues('trip')(state)
  const date = tripForm && tripForm.date ? tripForm.date : tripForm && tripForm.date_formatted
  const year = String(moment(date).year())

  // const deduction = tripForm ? tripForm.miles * tripForm.rate : 0
  const deduction = tripForm && tripForm.miles
    ? calculateDeduction(irs_mileage_rates, work_mileage_rate, tripForm.miles, tripForm.purpose, year) : 0


  const getNextTripId = ({models:{trips}}, currentTripId) =>{
    const nextTripIndex = trips.findIndex((v)=>v.token_id==currentTripId) + 1
    return trips[nextTripIndex] && trips[nextTripIndex].token_id
  }


  return {
    title: `Update Trip`,
    buttonTitle: 'Update trip',
    trip: tripForm,
    vehicleOptions: state.models.vehicles.map(v=>
      ({title: v.nickname || `${v.make} ${v.model}`, value: v.id, icon_name: v.icon_name})
    ),
    purposes: getPurposes(state),
    purposeSelectValue: (tripForm && tripForm.income_source) || (tripForm && tripForm.purpose) || 'Unclassified',
    date,
    calculate_route_enabled: tripForm&& tripForm.calculate_route_enabled,
    round_trip_enabled: tripForm && tripForm.round_trip_enabled,//map.round_trip_enabled,
    photo: tripForm && tripForm.photo,
    started_at: tripForm && tripForm.started_at,
    ended_at: tripForm && tripForm.ended_at,
    deduction,
    kms_enabled: state.models.user.kms_enabled,
    isFetching: state.trips.isFetching,
    wasMerged: tripForm && tripForm.parent_trip,
    auto_detected: tripForm && tripForm.auto_detected,
    hasOriginDestination: map.origin && map.destination,
    nextTripId: getNextTripId(state, ownProps.match.params.tripId)
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onDateChange: (e)=>dispatch(onDateChange(e)),
    save: ()=> dispatch(submit('trip')),
    toggleRoundTrip: (isEnabled)=> {
      dispatch(change('trip', 'round_trip_enabled', isEnabled))

      if (isEnabled) {
        dispatch(change('trip', 'calculate_route_enabled', true))
        // dispatch({type:'CLEAR_MAP'})
        dispatch({type: 'ENABLE_ROUND_TRIP'})
        dispatch(requestDirections())
      } else {
        // dispatch({type: 'CLEAR_MAP'})
        //
        // dispatch({type: 'CLEAR_DIRECTIONS'})
        dispatch({type: 'DISABLE_ROUND_TRIP'})

        dispatch(requestDirections())


      }
    },
    onPolylineClick: ()=> {
      dispatch(change('trip', 'calculate_route_enabled', true))
      dispatch(requestDirections())

    },
    toggleCalculateRoute: (isEnabled)=> {
      dispatch(change('trip', 'calculate_route_enabled', isEnabled))
      if (isEnabled) {
        dispatch(change('trip', 'round_trip_enabled', false))
        // // clear the static markers and polyline to make room for directions ui elements
        // dispatch({type: 'CLEAR_MAP'})
        dispatch(requestDirections())
      } else {
        dispatch({type:'CLEAR_DIRECTIONS'})
        dispatch({type:'POPULATE_MAP'})
      }
    },
    onSelectPurpose: (purpose)=> dispatch(onSelectPurpose(purpose)),
    onDelete: ()=>dispatch( deleteTrip(ownProps.match.params.tripId) )
      .then(()=>message.success('Deleted trip successfully.', 10))
      .then(()=> dispatch(push(`/trips`)) ),
    undoMerge: ()=>dispatch( undoMerge(ownProps.match.params.tripId) )
      .then(()=>message.success('Un-merged trip successfully.', 10))
      .then(()=> dispatch(push(`/trips`)) ),
    onUpload: (file)=> {
      dispatch(change('trip', 'photo_attributes', file))
      dispatch(change('trip', 'photo', null))
    },
    dispatch,
    ownProps
  }
}


export const geocodeLatLng = (str, cb) => {
  if (!window.google) {
    console.log('no google. will retry in 1 second')
    return setTimeout(()=>geocodeLatLng(str,cb), 500)
  }
  var geocoder = new window.google.maps.Geocoder
  geocoder.geocode({'address': str}, function(results, status) {
      if (results[0]) {
        cb(results[0].geometry.location.toJSON())
      }
    })
}

export const populateMap = (trip) => {
  return (dispatch)=>{
    if (!window.google) {
      console.log('no google. will retry in .5 seconds')
      return setTimeout(()=>dispatch(populateMap(trip)), 500)
    }
    dispatch({type:'POPULATE_MAP', payload: trip})
  }

}

const Update = reduxForm({
  form: 'trip',
  validate,
  onSubmit: (values, dispatch)=> dispatch(updateTrip(values))
    // .then(()=>message.success('Updated trip successfully.', 10))
    // .then(()=> dispatch(push(`/trips`)) ),
})(Trip)

const MountedUpdate = onMount(({dispatch, ownProps}) =>{
  dispatch(getTrip(ownProps.match.params.tripId))
    .then(trip=>{
      dispatch(initialize('trip', trip))

      // // TODO
      // if (!window.google) {
      //   console.log('no google. will retry')
      //   return setTimeout(()=>dispatch({type:'POPULATE_MAP', payload: trip}), 500)
      // } else {
      //   dispatch({type:'POPULATE_MAP', payload: trip})
      // }

      // // not included with the trip data are the from/to latLngs that we might need if the user untoggles a round trip
      // geocodeLatLng(trip.from, (latLng)=> dispatch({type:'SET_FROM_LAT_LNG', latLng}) )
      // geocodeLatLng(trip.to, (latLng)=> dispatch({type:'SET_TO_LAT_LNG', latLng}) )

      if (trip.start_place) {
        dispatch({type:'SET_ORIGIN', origin: {lat:trip.start_place.latitude, lng:trip.start_place.longitude}})
      } else {
        // dont geolocate if custom text == empty locations array
        trip.locations.length>0 && geocodeLatLng(trip.from, (latLng)=> dispatch({type:'SET_ORIGIN', origin: latLng}) )
      }

      if (trip.end_place) {
        dispatch({type:'SET_DESTINATION', destination: {lat:trip.end_place.latitude, lng:trip.end_place.longitude}})
        } else {
        // dont geolocate if custom text == empty locations array
        trip.locations.length>0 && geocodeLatLng(trip.to, (latLng)=> dispatch({type:'SET_DESTINATION', destination: latLng}) )
      }

      dispatch(populateMap(trip))
    })
})(Update)


export default connect(mapStateToProps, mapDispatchToProps)(MountedUpdate)



// WEBPACK FOOTER //
// ./src/trips/Update.js